<template>
  <div>
    <h3>Test Completed Successfully!!</h3>
    <h4>Results will be communicated to you separately</h4>
  </div>
</template>

<script>
import dbStore from "../db/dbStore";
import config from "../config";

export default {
  created() {
    this.getStudentInfo();
  },
  data() {
    return {
      //
    };
  },
  computed: {
    login_details: function() {
      return this.$store.getters.get_login_details;
    }
  },
  methods: {
    async getStudentInfo() {
      console.log("In successTest " + this.$attrs.id);
      if (this.$attrs.id === 0) return {};
      else {
        //dbStore.setCollectionName("students");
        //let studentInfo = await dbStore.getItem(this.$attrs.id);
        dbStore.setCollectionName("studentsprofile");
        let studentProfileInfo = await dbStore.getItem(this.$attrs.id);
        dbStore.setCollectionName("centers");
        //let center = await dbStore.getItem("1");
        //TODO Handle the case where centerId is 0 i.e. not center managers
        let center = await dbStore.getItem(this.login_details.centerId);

        let cert = {
          //#TODO change type from static to dynamic data
          type: "ndlm",
          body: [
            {
              filename: studentProfileInfo.IdNo,
              name:
                studentProfileInfo.FirstName +
                " " +
                studentProfileInfo.LastName,
              donor: center.donor,
              aadhar_no: studentProfileInfo.IdNo,
              partner: center.partner
            }
          ],
          email: center.center_manager.email
        };

        if (cert.hasOwnProperty("type")) {
          //TODO move post methods to different library
          var url = config().cloudFunctions.sendReceipt;
          fetch(url, {
            method: "POST",
            body: JSON.stringify(cert),
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(function(response) {
            let body = response.json();
            console.log("Fetch Response: " + JSON.stringify(body));
            return body;
          })
          .catch(err => {
            console.log("Fetch Error: " + err);
          });
        } else {
          console.log("Improper input!");
        }
      }
    }
  }
};
</script>

<style scoped>
h3 {
  color: green;
  font-size: 25px;
  text-align: center;
  margin: auto;
  padding: 100px;
}

h4 {
  color: green;
  font-size: 15px;
  text-align: center;
  margin: auto;
  padding: 100px;
}
</style>
